import React, { useState } from 'react'
import * as styles from './index.module.css'
import InfoIcon from '../../../assets/images/infoIcon.svg'
import { GatsbyImage } from 'gatsby-plugin-image'
import DownCaret from '../../../assets/images/downcaretWhite.svg'

const OsBackground = (props) => {
  const [displayMobileDesc, setMobileDescVisibility] = useState(false)
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <GatsbyImage
          image={props.images[0].gatsbyImageData}
          className={styles.heroImage}
          alt={props.images[0]?.description}
        />
        <div className={styles.description}>{props.images[0].description}</div>
        <InfoIcon
          className={styles.infoIcon}
          onClick={() => setMobileDescVisibility(!displayMobileDesc)}
        />
        <div
          className={styles.mobileDescriptionBox}
          style={{ display: displayMobileDesc ? 'block' : 'none' }}
        >
          <div className={styles.mobileDescription}>
            {props.images[0].description}
          </div>
          <DownCaret className={styles.downCaret} />
        </div>
      </div>
    </div>
  )
}

export default OsBackground
